import { Component, OnInit } from '@angular/core';
import { ServiceTypeEnum, RootMenuEnum, MenuPermissionConfig, MenuPermissionActionEnum } from 'app/models';
import { AppDataService } from 'app/services';
import { AppComponent } from 'app/app.component';

export enum SettingsMenuEnum {
    SystemStatus = 1,
    SystemStatusOverview = 2,
    SystemStatusPlayStore = 3,
    SystemStatusAppStore = 4,
    VehicleAndFares = 5,
    Vehicle = 6,
    Coding = 7,
    CodingETrike = 8,
    CodingMulticab = 9,
    CodingVan = 10,
    CodingMinibus = 11,
    UserManagment = 12,
    UserManagmentAllUsers = 13,
    UserManagmentRoles = 14,
    Security = 15,
    SecurityPasswordManagment = 16,
    SecurityUserAudit = 17,
    SecurityPlatformAlerts = 18,
    SecuritySuspiciousActivities = 19,
    SystemFlags = 20,
    MapsRegionMapEditor = 21,
}

@Component({
    selector: 'settings-root',
    templateUrl: './settings-root.component.html',
    styleUrls: ['./settings-root.component.scss',
        '../../../../../styles/menu-sidebar.scss'
    ],
})
export class SettingsRootComponent implements OnInit {

    public serviceTypeId!: ServiceTypeEnum;

    constructor(public appData: AppDataService, public app: AppComponent) { }

    public menuPermissionConfig = MenuPermissionConfig;
    public menuPermissionActionEnum = MenuPermissionActionEnum;

    public menuPermissionActive!: string;

    public activeRootMenu: RootMenuEnum | null = null;

    public menuEnum = SettingsMenuEnum;
    public activeMenu: SettingsMenuEnum = SettingsMenuEnum.SystemFlags;

    ngOnInit(): void {
        //this.activeRootMenu = this.appData.activeRootMenu;
    }

    public clickMenu(menuPermissionActive: string, menu: SettingsMenuEnum) {
        this.menuPermissionActive = menuPermissionActive;
        this.activeMenu = menu;
    }
}
